import { jsx as _jsx } from "react/jsx-runtime";
import { useBrandConfiguration } from '@search/core/brands/context';
import { BasePagination } from '@search/core/components/BasePagination';
import { useAppContext } from '../../contexts/AppContext';
export const PaginationTestId = 'serp-pagination-testid';
export const Pagination = () => {
    const { pageSize } = useBrandConfiguration();
    const [totalCount, page, setPage] = useAppContext((store) => [store.totalCount, store.page, store.setPage]);
    return (_jsx(BasePagination, { testId: PaginationTestId, totalCount: totalCount, page: page, pageSize: pageSize, onChange: setPage }));
};
